import React from 'react'

const CareerProspects = ({ data }) => {
    return (
        <section className="page-container bg-[#011F31]">
            <div className="py-10 lg:py-20">

                <p className="text-[11px] tracking-[2px] text-[#FFA201] 
                    uppercase mb-2 inline-block bg-[#FFA2011A] px-2 py-2">
                    {data.tag}
                </p>
                <h2 className="mb-2 font-bold text-white text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px]">{data.heading}</h2>

                <p className="text-white w-full md:w-[80%] xl:w-[60%] mb-7 md:mb-10">
                    {data.description}
                </p>

                <div className="flex flex-wrap gap-4">
                    {data.roles.map((prospect, index) => (
                        <div
                            key={index}
                            className="flex items-center space-x-2 bg-[#0091E3] text-white font-medium px-6 py-4 lg:px-7 lg:py-4 rounded-full shadow-lg transition duration-300 ease-in-out cursor-pointer"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                            >
                                <rect width="22" height="22" rx="11" fill="white"></rect>
                                <path
                                    d="M15.7767 8.64236L15.3457 8.20161C15.1681 8.02004 14.8782 8.02004 14.6991 8.20161L10.1797 12.8249L7.81225 10.4038C7.6347 10.2222 7.34482 10.2222 7.16575 10.4038L6.73473 10.8446C6.55717 11.0262 6.55717 11.3226 6.73473 11.5057L9.85495 14.6965C9.9445 14.7881 10.0598 14.8347 10.1767 14.8347C10.2935 14.8347 10.4104 14.7881 10.4984 14.6965L15.7721 9.30351C15.9542 9.11884 15.9542 8.82397 15.7767 8.64236Z"
                                    fill="#0475B3"
                                ></path>
                            </svg>

                            <span className="text-[16px] lg:text-[18px]">{prospect}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default CareerProspects